/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCVClosedIcon16Regular = forwardRef('ArrowCollapseCVClosedIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.379 6.432a1.95 1.95 0 0 1-2.758 0L3.97 3.78a.75.75 0 0 1 1.06-1.06L7.682 5.37a.45.45 0 0 0 .636 0L10.97 2.72a.75.75 0 0 1 1.06 1.06L9.38 6.432Z" }),
        React.createElement("path", { d: "M9.379 9.568a1.95 1.95 0 0 0-2.758 0L3.97 12.22a.75.75 0 0 0 1.06 1.06l2.652-2.651a.45.45 0 0 1 .636 0l2.652 2.651a.75.75 0 0 0 1.06-1.06L9.38 9.568Z" })));
});
